import { InlineText2 } from '@cian/ui-kit';
import * as React from 'react';

interface IPositionProps {
  pagePosition: string;
  offerPosition: string;
}

export const Position = ({ pagePosition, offerPosition }: IPositionProps) => {
  return (
    <InlineText2 color="current_color">
      {pagePosition} страница, {offerPosition} место
    </InlineText2>
  );
};
